import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// Components
import GLTransTable from "./GLTransTable"; //reused table component
import GLAddItem from "./GLAddItem"; //reused modal component
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn, timeZoneChanger} from "../../components/Cookies/Cookies";
//number format plugin
import numeral from "numeral";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import MessageBox from "../../components/MessageBox/MessageBox";
import { Breadcrumbs, Typography } from "@material-ui/core";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
});

const GLTransaction = () => {
	// const { chkno, branchidno } = useParams();
	const branchIdNo = get_cookies('branchidno')
	const [purchaseType, setPurchaseType] = useState([]);
	const [supplier, setSupplier] = useState([]);
	const [glAccounts, setGlAccounts] = useState([]);
	const [supplierId, setSupplierId] = useState([]);
	const [reference, setReference] = useState('');
	const classes = useStyles();
	const [poTotal, setPoTotal] = useState(0);
	const [selectedDate, setSelectedDate] = React.useState(null);
	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [showModal, setShowModal] = useState(false);
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");

	let history = useHistory();
	const [items, setItems] = useState([]); //data to display in table

	useEffect(() => {
		let po_total = 0;
		items.forEach(item => po_total += (item.c_amount))
		setPoTotal(po_total);
		if(items.length > 0) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [items]);

	const handleDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setSelectedDate(date);
	};

	const checkType = [
		{
			type:'Purchases'
		}
	]

	const checkSupplierProps = {
		options: checkType,
		getOptionLabel: (option) => option.type,
	};
	const selectSupplierProps = {
		options: supplier,
		getOptionLabel: (option) => option.suppliername,
	};
	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		timeZoneChanger(setSelectedDate);
		isLoggedIn();
	}, [x]);

	const getSupplierList = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/get_supplier_list', {
			params:{
				jc_user_id_no: branchIdNo,  //branchIdNo
			}
		}).then((res)=>{
			setSupplier(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		});
	}
	const getGlAccountList = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'gl_accounts_list', {
		}).then((res)=>{
			setGlAccounts(res.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		});
	}
	

	const data = async () => {
		getSupplierList();
		getGlAccountList();
	};	

	const addItem = (item) => {
			//id added for easier deleting 
			setItems([...items, 
				{
				id: item.id, 
				c_date: format(new Date(item.c_date),'yyyy-MM-dd'), 
				c_desc: item.c_desc,
				c_amount: item.c_amount, 
				c_gliddebit: item.c_gliddebit,
				c_glidcredit: item.c_glidcredit,
				c_gliddebit_name: item.c_gliddebit_name,
				c_glidcredit_name: item.c_glidcredit_name
				}
			]);
	}	
	const deleteItem = (id) => {
		//console.log(id);
		let itemArray = items.filter(item => item.id != id);
		setItems(itemArray);
	}

	// item_array:
	// {
	// "c_date": "2021-03-30",
	// "c_desc": "postman api",
	// "c_amount": "5000",
	// "c_gliddebit": "2",
	// "c_glidcredit": "3"
	// }
// 	jc_uname:superuser
// jc_u_idno:DAVAOHQ


const save_gl = async () => {
	setBtnDisabled(true); // disable button to avoid multiple saves
	setShowModal(true); //show loading/please wait modal
	const formData = new FormData();
	formData.append("item_array", JSON.stringify(items));
	formData.append("jc_uname", get_cookies('username'));
	formData.append("jc_u_idno", get_cookies('branchidno'));

	await axios.post(process.env.REACT_APP_API_URL+'save_gl_trans', formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
			}
		}).then(function (res) {
			setShowModal(false); //hide loading/please wait modal
			setShowMsgBox(true);
			setMsg("Added New GL Transaction");
			setMsgType("success");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
				// history.push(`/account/gl-transaction-history-view/${res.data.glid}`);
				history.push(`/account/gl-transaction-history`);
			}, 2000)
		  }).catch(function (error) {
			setShowModal(false); //hide loading/please wait modal 
			setShowMsgBox(true);
			setMsg("Something went wrong: "+error);
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
			}, 2500)
		  });
}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceWalletIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/account">
						<h2 className="header-title">Accounts</h2>
					</NavLink>
					<Typography color="textPrimary">Gl Transaction</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.title}>
									GL Transaction
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
							
								item
								xs={2}
								className={classes.buttonContainer}
							>
								{glAccounts ? (<GLAddItem addItem={addItem} glAccounts={glAccounts}/>) :(<></>)}
							</Grid>
						</Grid>
					</div>	
					<CardContent>
						<GLTransTable items={items} deleteItem={deleteItem}/>
							<div className={classes.infoTotal}>
								<div className={classes.infoTotalContent}>
									<div className={classes.infoTotalItem}>
										<ShoppingCartTwoToneIcon
											className={classes.infoTotalIcon}
										/>
										{"Total: "+ numeral(poTotal).format('0,0.00')}
									</div>	
								</div>
							</div>
					</CardContent>
				</Card>
					<br/>					
					<div className={classes.buttonContainer}>
					{/* <Button variant="contained">Back</Button>  */}
					<Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{save_gl()}}>
						Save GL Transaction
					</Button>
					</div>
				</div>
			</div>
	);
};

export default GLTransaction;
